import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import PropTypes from 'prop-types';
import SearchSuggestionItem from './SearchSuggestionItem';

const useStyles = makeStyles(theme => ({
  root: {
    listStyle: 'none',
    margin: theme.spacing(2),
    '& a strong': {
      fontWeight: 'bold',
      color: 'inherit'
    }
  },
  caption: {
    textTransform: 'uppercase',
    fontWeight: 'bold',
    paddingBottom: 5,
    borderBottom: `1px solid ${theme.palette.divider}`,
    margin: theme.spacing(0, 0, 1, 0)
  },
  list: {
    '&[data-ui=list]': {
      padding: 0,
      margin: theme.spacing(0, 0, 4, 0)
    },
    '&[data-ui=thumbnails]': {
      display: 'flex',
      listStyle: 'none',
      // margin: '0 -15px',
      padding: '0 10px',
      overflowX: 'auto',
      '& > li': {
        margin: '5px'
      }
    }
  }
}));

function SearchSuggestionGroup({ classes, ui, caption, links, children }) {
  const styles = useStyles();

  return (
    <div className={styles.root}>
      <Typography className={styles.caption}>{caption}</Typography>
      <ul className={styles.list} data-ui={ui}>
        {children ? children : links.map((item, i) => (
          <SearchSuggestionItem item={item} ui={ui} key={i} />
        ))}
      </ul>
    </div>
  );
}

SearchSuggestionGroup.propTypes = {
  classes: PropTypes.object,
  children: PropTypes.node,
  links: PropTypes.arrayOf(PropTypes.shape({
    as: PropTypes.string,
    href: PropTypes.string,
    text: PropTypes.string,
    pageData: PropTypes.object,
    thumbnail: PropTypes.object
  })),
  caption: PropTypes.string.isRequired
};

export default SearchSuggestionGroup;